<template>
  <el-table-column :label="label" :prop="prop" class-name="noise-level" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '騒音値'
    },
    prop: {
      type: String,
      default: 'noise_level'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.noise-level {
      width: 8em;
    }
  }
  td.noise-level  {
    text-align: right;
  }
}
</style>
